'use client';

import { IconButton } from '../../../components/icon-button';
import { Tooltip } from '../../../components/tooltip';
import { Box } from '@terra/ui-styled-system';
import { Clock01Icon } from '@terra/ui-icons';
import type { ConversationHistoryTriggerProps } from './types';

export function ConversationHistoryTrigger({
  isOpen,
  onOpenChange,
  labels,
  showStreamingIndicator,
  triggerVariant = 'ghost',
}: ConversationHistoryTriggerProps) {
  return (
    <Tooltip
      title={labels.triggerAriaLabel}
      openDelay={50}
      positioning={{ placement: 'bottom', strategy: 'fixed' }}
    >
      <IconButton
        variant={triggerVariant}
        size="xs"
        aria-label={labels.triggerAriaLabel}
        aria-pressed={isOpen}
        flexShrink={0}
        color={isOpen ? 'fg.default' : 'fg.muted'}
        onClick={() => onOpenChange(!isOpen)}
        _hover={{
          color: 'fg.default',
          bg: 'transparent',
        }}
        w="7"
        h="7"
      >
        <Box position="relative" display="inline-flex">
          <Clock01Icon size={16} />
          {showStreamingIndicator ? (
            <Box
              position="absolute"
              top="-1px"
              right="-1px"
              w="5px"
              h="5px"
              borderRadius="full"
              bg="colorPalette.default"
              pointerEvents="none"
            />
          ) : null}
        </Box>
      </IconButton>
    </Tooltip>
  );
}
